import React from "react";
import AuthHeader from "../layout/AuthHeader";

const ErrorPage = () => {
  return (
    <div className="min-h-full pt-16 pb-12 flex flex-col bg-white fixed inset-0">
      <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex-shrink-0 flex justify-center">
          <AuthHeader />
        </div>
        <div className="py-16">
          <div className="text-center">
            <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
              Qualcosa non ha funzionato
            </h1>
            <p className="mt-2 text-base text-gray-500">
              Contattaci al più presto
            </p>
            <div className="mt-6">
              <a
                href="/"
                className="text-base font-medium text-am-600 hover:text-am-500"
              >
                Go back home<span aria-hidden="true"> &rarr;</span>
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ErrorPage;
